// extracted by mini-css-extract-plugin
module.exports = {"footer_container":"footer_footer_container__3OTn1","responsive_padding":"footer_responsive_padding__3c1AF","footer_menu":"footer_footer_menu__33MR2"};